import React, {useState, useEffect, useRef, useContext} from 'react';
import useKeyPress from '../../../hooks/useKeyPress';
import {numbers, specialCharTextNumbers} from '../../views/textNumber-input/text-number';
import TextNumberEntryView from '../../views/textNumberEntryView';
import NumberView from '../../views/numberTNView';
import MenuContext from '../../../context/menuContext';

function CodeOptionsTN({onExit, isDisabled}) {
  const [value, setValue] = useState(10);

  useEffect(() => {}, [value]);
  return (
    <TextNumberEntryView
      chars={specialCharTextNumbers}
      focus={3}
      onChange={v => setValue(v)}
      defaultKey1={0}
      defaultKey2={0}
      defaultKey3={53}
      defaultKey4={14}
      defaultKey5={53}
      defaultKey6={65}
      defaultKey7={53}
      defaultKey8={15}
      defaultKey9={53}
      defaultKey10={65}
      defaultKey11={53}
      defaultKey12={0}
      onSave={onExit}
      onLeftHold={onExit}
      title="Model Code Options"
      caption="Set Model Code Options"
      left="Hold to Cancel"
      right="Hold to Save"
    />
  );
}

export default CodeOptionsTN;
